import React from "react";
import styles from "./StatusBadge.module.scss";

export type StatusBadgeVariant = "onTrack" | "atRisk" | "breached" | "completed" | "unknown" | "refunded";

interface StatusBadgeProps {
	variant: StatusBadgeVariant;
	children: React.ReactNode;
	className?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ variant, children, className = "" }) => {
	return (
		<span className={`${styles.badge} ${styles[variant]} ${className}`}>
			<span className={styles.dot} />
			{children}
		</span>
	);
};

export default StatusBadge;
